export default __webpack_public_path__ + "static/henry-preston-b2d3f760b7c0edee804bc74496320401.webp";